import { render, staticRenderFns } from "./serviceDetails.vue?vue&type=template&id=2d78a911&scoped=true&"
import script from "./serviceDetails.vue?vue&type=script&lang=js&"
export * from "./serviceDetails.vue?vue&type=script&lang=js&"
import style0 from "./serviceDetails.vue?vue&type=style&index=0&id=2d78a911&prod&scoped=true&lang=css&"
import style1 from "./serviceDetails.vue?vue&type=style&index=1&id=2d78a911&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d78a911",
  null
  
)

export default component.exports